// extracted by mini-css-extract-plugin
module.exports = {"box":"box--1XCnO","contact":"contact--1hypj","card":"card--19m0B","first":"first--uGBAU"};